const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessPlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.4,392s77.86,3.64,127.11-84.35-8.7-168.93-98.22-186.42S183.17,38.07,103.38,88.34,67.93,406.33,288.4,392Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.4,392s77.86,3.64,127.11-84.35-8.7-168.93-98.22-186.42S183.17,38.07,103.38,88.34,67.93,406.33,288.4,392Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-32"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.01,
    cy: 419.59,
    rx: 187.6,
    ry: 11.63,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.01,
    cy: 419.59,
    rx: 187.6,
    ry: 11.63,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.08,113.24l-.54,4.58,2.48.88a20.29,20.29,0,0,0,.65,4.65l-2.15,1.56,1.81,4.25,2.61-.49a20.2,20.2,0,0,0,2.88,3.7l-1.09,2.44,3.7,2.76,2-1.7a19.74,19.74,0,0,0,4.35,1.76l.28,2.65,4.57.55.89-2.49a20.29,20.29,0,0,0,4.65-.65l1.57,2.14L324,138l-.47-2.6a20.23,20.23,0,0,0,3.69-2.88l2.44,1.09,2.76-3.7-1.71-2a19.47,19.47,0,0,0,1.76-4.34l2.65-.28.55-4.58-2.49-.89a19.67,19.67,0,0,0-.65-4.64l2.16-1.57-1.82-4.25-2.6.48a20.28,20.28,0,0,0-2.89-3.69l1.08-2.43L324.73,99l-2,1.71a20.52,20.52,0,0,0-4.32-1.76l-.28-2.65-4.58-.54-.89,2.48a20.14,20.14,0,0,0-4.64.66l-1.57-2.15-4.25,1.81.48,2.6A20.2,20.2,0,0,0,299,104l-2.43-1.08-2.77,3.7,1.71,2a19.83,19.83,0,0,0-1.76,4.35Zm10.63,3.67a11.46,11.46,0,1,1,10,12.73h0a11.46,11.46,0,0,1-10-12.73Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.57112px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.61,225.94l-.49,4.15,2.25.8a18.19,18.19,0,0,0,.59,4.21l-2,1.42,1.64,3.85,2.36-.45a18.49,18.49,0,0,0,2.61,3.35l-1,2.21L181,248l1.81-1.55a17.71,17.71,0,0,0,3.94,1.6l.25,2.4,4.15.5.8-2.26a18,18,0,0,0,4.21-.59l1.42,1.95,3.84-1.65L201,246a18.49,18.49,0,0,0,3.35-2.61l2.21,1,2.5-3.34-1.55-1.83a17.92,17.92,0,0,0,1.6-3.93l2.4-.26.49-4.15-2.25-.8a18.19,18.19,0,0,0-.59-4.21l2-1.42-1.65-3.85-2.35.43a18.45,18.45,0,0,0-2.63-3.33l1-2.21L202.1,213l-1.82,1.55a17.81,17.81,0,0,0-3.92-1.59l-.25-2.4-4.15-.5-.8,2.26a18.11,18.11,0,0,0-4.21.59L185.53,211l-3.85,1.64.43,2.36a18.39,18.39,0,0,0-3.35,2.61l-2.21-1-2.5,3.35,1.55,1.82a18.2,18.2,0,0,0-1.6,3.94Zm9.63,3.32a10.38,10.38,0,1,1,9.08,11.54h0a10.39,10.39,0,0,1-9.08-11.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.08,327.75v-9.41l-5.25-1.19a40.53,40.53,0,0,0-2.44-9.26l4-3.69L374.67,296l-5.16,1.63a41.23,41.23,0,0,0-6.74-6.79l1.63-5.21-8.17-4.71-3.65,3.93a40.52,40.52,0,0,0-9.24-2.51l-1.2-5.3h-9.41l-1.2,5.26a40.15,40.15,0,0,0-9.26,2.44l-3.69-4-8.15,4.7,1.59,5.16a41.17,41.17,0,0,0-6.79,6.73l-5.2-1.61-4.7,8.14,3.94,3.67a40.57,40.57,0,0,0-2.51,9.23l-5.3,1.21v9.41l5.25,1.2a41.11,41.11,0,0,0,2.44,9.25l-4,3.7,4.71,8.17,5.15-1.59a40.79,40.79,0,0,0,6.76,6.76l-1.61,5.21,8.18,4.71,3.65-4a40.27,40.27,0,0,0,9.19,2.52l1.2,5.3h9.42l1.19-5.25a41.17,41.17,0,0,0,9.27-2.46l3.69,4,8.17-4.71-1.59-5.15a40.79,40.79,0,0,0,6.79-6.73l5.2,1.61,4.71-8.18-3.95-3.66a41.06,41.06,0,0,0,2.52-9.24Zm-16.27-4.86a29.54,29.54,0,1,1-29.54-29.54h0a29.54,29.54,0,0,1,29.54,29.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.34,
    y: 94.15,
    width: 24.24,
    height: 5.59,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.34,
    y: 102.23,
    width: 15.93,
    height: 5.59,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.34,
    y: 110.31,
    width: 9.17,
    height: 5.59,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.34,
    y: 94.15,
    width: 24.24,
    height: 5.59,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.34,
    y: 102.23,
    width: 15.93,
    height: 5.59,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.34,
    y: 110.31,
    width: 9.17,
    height: 5.59,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.25,
    y: 156.07,
    width: 8.22,
    height: 16.84,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.12,
    y: 161.86,
    width: 8.22,
    height: 11.06,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 166.55,
    width: 8.22,
    height: 6.37,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.25,
    y: 156.07,
    width: 8.22,
    height: 16.84,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.12,
    y: 161.86,
    width: 8.22,
    height: 11.06,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 166.55,
    width: 8.22,
    height: 6.37,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.94,185.66H151.41A10.39,10.39,0,0,1,141,175.27V93.1a10.41,10.41,0,0,1,10.39-10.39h99.53A10.4,10.4,0,0,1,261.33,93.1v82.17A10.39,10.39,0,0,1,250.94,185.66Zm-99.53-102a9.5,9.5,0,0,0-9.48,9.48v82.17a9.5,9.5,0,0,0,9.48,9.48h99.53a9.5,9.5,0,0,0,9.48-9.48V93.1a9.5,9.5,0,0,0-9.48-9.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.17,
    y: 156.53,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.17,
    y: 160.34,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.17,
    y: 164.14,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.17,
    y: 167.94,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.17,
    y: 171.74,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.16,
    y: 94.53,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.16,
    y: 98.33,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.16,
    y: 102.13,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.16,
    y: 105.93,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.16,
    y: 109.73,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.65,125.23l6.36,3.34-.73-17.94-15.17,9.6,6.36,3.33-4.79,9.11h0a3.78,3.78,0,0,0-2.33.8l-8.45-3.91v-.05a3.88,3.88,0,0,0-7.75-.38h0a2.41,2.41,0,0,0,0,.38,4.05,4.05,0,0,0,.35,1.61l-11,12a3.7,3.7,0,0,0-1.09-.17,2.76,2.76,0,0,0-.57.06L188,122.9a3.87,3.87,0,0,0-7.08-3.11,3.71,3.71,0,0,0-.33,1.54,4.29,4.29,0,0,0,.2,1.17L162.74,141a3.87,3.87,0,1,0,2.31,5h0a4,4,0,0,0,.23-1.33,3.38,3.38,0,0,0-.13-.94L183.4,125a3.53,3.53,0,0,0,1.11.18,3.42,3.42,0,0,0,.71-.07l15.75,20a3.91,3.91,0,1,0,6.88,3.73,3.83,3.83,0,0,0,.47-1.65,2.54,2.54,0,0,0,0-.39,4,4,0,0,0-.2-1.19l11.26-12.26a3.57,3.57,0,0,0,.65.06,3.87,3.87,0,0,0,2.16-.66l8.6,4a3.87,3.87,0,1,0,7.73-.37,3.83,3.83,0,0,0-.69-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-1--inject-2--inject-32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.17,196.27a5.91,5.91,0,0,0-5.9,5.91v51.21a5.9,5.9,0,0,0,5.9,5.9h62a5.91,5.91,0,0,0,5.91-5.9V202.15a5.91,5.91,0,0,0-5.91-5.9Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.16,
    y: 203.25,
    width: 4.71,
    height: 0.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.16,
    y: 208.39,
    width: 4.71,
    height: 0.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.16,
    y: 213.53,
    width: 4.71,
    height: 0.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.16,
    y: 218.68,
    width: 4.71,
    height: 0.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.98,
    y: 208.39,
    width: 4.71,
    height: 0.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.16,
    y: 223.82,
    width: 4.71,
    height: 0.63,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M285.76,251.64a22.59,22.59,0,1,0-22.12-23,22.58,22.58,0,0,0,22.12,23Zm.79-38.54a16,16,0,1,1-16.32,15.67A16,16,0,0,1,286.55,213.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.76,251.64a22.59,22.59,0,1,0-22.12-23,22.58,22.58,0,0,0,22.12,23Zm.79-38.54a16,16,0,1,1-16.32,15.67A16,16,0,0,1,286.55,213.1Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,245.22a23,23,0,0,0,32.53.14.48.48,0,0,0,0-.64L297.84,240a.45.45,0,0,0-.32-.14.57.57,0,0,0-.33.13,15.36,15.36,0,0,1-11.28,4.51l-1.11,0a15.45,15.45,0,0,1-9.21-3.71c-.23-.21-.47-.42-.69-.64a15.79,15.79,0,0,1-1.75-20.27.41.41,0,0,0,.05-.09c.1-.14.21-.26.33-.4a15.47,15.47,0,0,1,13-5.86.45.45,0,0,0,.46-.44h0l.13-6.63a.46.46,0,0,0-.44-.47h0A23,23,0,0,0,270,245.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.69,206a23.51,23.51,0,1,1-.05,0Zm-.92,45.17a22.14,22.14,0,1,0-21.68-22.58h0A22.15,22.15,0,0,0,285.77,251.18Zm.79-38.54a16.42,16.42,0,1,1-16.75,16.08,16.42,16.42,0,0,1,16.75-16.08Zm-.65,31.91a15.51,15.51,0,1,0-15.19-15.82h0a15.51,15.51,0,0,0,15.19,15.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.67,
    y1: 278.13,
    x2: 169.67,
    y2: 338.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.27,
    y: 301.02,
    width: 5.15,
    height: 34.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.63,
    y: 315.19,
    width: 5.15,
    height: 20.55,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.28,
    y: 289.79,
    width: 5.15,
    height: 45.96,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.64,
    y: 283.16,
    width: 5.15,
    height: 52.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.01,
    y: 322.74,
    width: 5.15,
    height: 13.01,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.66,
    y: 304.7,
    width: 5.15,
    height: 31.05,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.64,
    y: 309.45,
    width: 5.15,
    height: 26.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.01,
    y: 289.05,
    width: 5.15,
    height: 46.69,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.66,
    y: 299.36,
    width: 5.15,
    height: 36.38,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.14,
    y1: 327.71,
    x2: 167.02,
    y2: 327.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.14,
    y1: 320.22,
    x2: 167.02,
    y2: 320.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.14,
    y1: 312.74,
    x2: 167.02,
    y2: 312.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.14,
    y1: 305.25,
    x2: 167.02,
    y2: 305.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.14,
    y1: 297.76,
    x2: 167.02,
    y2: 297.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.14,
    y1: 290.27,
    x2: 167.02,
    y2: 290.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.14,
    y1: 282.78,
    x2: 167.02,
    y2: 282.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.26,
    y1: 335.75,
    x2: 266.42,
    y2: 335.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.63,
    y: 315.19,
    width: 5.15,
    height: 20.55,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.01,
    y: 322.74,
    width: 5.15,
    height: 13.01,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.01,
    y: 289.05,
    width: 5.15,
    height: 46.69,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.05,269.71a6.52,6.52,0,0,0-6.51,6.51v59.51a6.53,6.53,0,0,0,6.51,6.52H270.5a6.54,6.54,0,0,0,6.52-6.52V276.2a6.53,6.53,0,0,0-6.52-6.52Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessPlan);
export default __webpack_public_path__ + "static/media/business-plan.dc42ca621b564fda4bc1814fe09a860e.svg";
export { ForwardRef as ReactComponent };